import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    Renderer2,
    ViewEncapsulation,
} from '@angular/core';
import { ContactService } from '../contact.service';
import { FiCustomerDataService } from '../../fi-shared-services/fi-customer-data.service';
import { isDefined } from '../../utils';
import { IContactModel } from '../../models/common';
import { IContactInformationType } from '../fi-contacts-base.directive';
import { AppTextService } from '../../app-text';
import { IFiContactData } from '../fi-contacts';

@Component({
    selector: 'fi-contact-type',
    templateUrl: './contact-type.component.html',
    styleUrls: ['./contact-type.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-contact-type' },
    standalone: false,
})
export class ContactTypeComponent implements OnInit, OnDestroy {
    @Input() contact: IContactModel;
    @Input() contactTypes: IContactInformationType[];
    @Input() contactTypeName: string;
    @Input() labelTextId: string = 'common.type';

    @Input({ required: true }) contactData: IFiContactData;

    @Output() isDefaultSet: EventEmitter<any> = new EventEmitter<IContactModel>();
    @Output() contactTypeChange = new EventEmitter<IContactInformationType>();
    @Output() isSignInSet = new EventEmitter<IContactModel>();

    IsToggle: boolean = false;
    private documentListener;
    selectedType: IContactInformationType;

    constructor(
        private renderer: Renderer2,
        private elementRef: ElementRef,
        private contactService: ContactService,
        private customerDataService: FiCustomerDataService,
        private appTextService: AppTextService,
    ) {}

    ngOnInit() {
        this.selectedType = this.getSelectedType();
    }

    getPrimaryText() {
        return this.appTextService.get(this.contactData.primaryTextId);
    }

    ngOnDestroy() {
        if (this.documentListener) {
            this.documentListener();
        }
    }

    isSignInOptionShown() {
        return this.contactData.isSignInOptionShown();
    }

    getSignInText() {
        return this.appTextService.get(this.contactData.signInTextId);
    }

    getContactTypes(): IContactInformationType[] {
        return this
            .contactTypes /*.filter(contactType => this.customerDataService.isADLogin() || !this.contactService.isImported(contactType.Id))*/;
    }

    isChangeContactTypeDisabled(contactTypeId): boolean {
        return this.contactService.isContactImported(this.contact);
    }

    isContactTypeSelected(id: number): boolean {
        return id === this.selectedType.Id;
    }

    ChangeContactType(id: number, $event?: MouseEvent) {
        if (isDefined($event)) {
            $event.stopPropagation();
        }
        if (this.isChangeContactTypeDisabled(id)) {
            return;
        }
        this.contact[this.contactTypeName] = id;
        this.selectedType = this.getSelectedType();
        this.contactTypeChange.emit(this.selectedType);
    }

    getSelectedType(): IContactInformationType {
        for (let i = 0; i < this.contactTypes.length; i++) {
            if (this.contactTypes[i].Id === this.contact[this.contactTypeName]) {
                return this.contactTypes[i];
            }
        }
        return this.contactTypes[0];
    }

    Toggle() {
        if (this.IsToggle) {
            this.closeDropdown();
        } else {
            this.openDropdown();
        }
    }

    openDropdown() {
        this.IsToggle = true;
        this.documentListener = this.renderer.listen('document', 'click', (event) => {
            if (!this.elementRef.nativeElement.contains(event.target)) {
                this.closeDropdown();
            }
        });
    }

    onToggleDefault() {
        this.isDefaultSet.emit(this.contact);
    }

    onSignInToggle() {
        this.isSignInSet.emit(this.contact);
    }

    closeDropdown() {
        this.IsToggle = false;
        if (this.documentListener) {
            this.documentListener();
        }
    }

    isSelectAsDefaultDisabled(): boolean {
        return this.contactData.selectAsDefaultDisabled(this.contact);
    }

    isSelectAsDefaultHidden(): boolean {
        return !this.contactData.showSelectAsDefault(this.contact);
    }

    isSelectAsSignInHidden(): boolean {
        return !this.contactData.showSelectAsSignIn(this.contact);
    }

    isPKSignInOptionDisabled(): boolean {
        return this.contactData.isPKSignInOptionDisabled();
    }
}
